/* eslint-disable */
import $ from "jquery";
import Headroom from "headroom.js";

// keyboard keys
const keyboard = {
    enter: 13,
};

// search results markup
const generateAutocompleteMarkup = (phrase, results = [], url) => {
    let markup = "";
    results.forEach((result) => {
        const regex = new RegExp(phrase, "gi");
        const highlight = result.replace(regex, `<b>${phrase}</b>`);
        markup += `<li class="menu-search-result"><a href="${url}${result}">${highlight}</a>`;
    });
    return markup;
};

// reset results
const resetAutocompleteResults = ($results, activeClass) => {
    $results.removeClass(activeClass);
    setTimeout(() => $results.html(""), 350);
};

// freeze / unfreeze headroom instance
const freeze = (headroom, value = true, delay = 0) => {
    if (value) headroom.freeze();
    else headroom.unfreeze();
};

// intialize plugin
const init = (opts = {}) => {
    // default options
    const defaults = {
        selector: {
            menu: ".js-menu",
            nav: ".js-menu-nav",

            link: ".js-menu-link",
            drawer: ".js-menu-drawer",

            search: ".js-menu-search",
            icon: ".js-menu-search-icon",
            input: ".js-menu-search-input",
            results: ".js-menu-search-results",

            languages: ".js-menu-languages",
            language: ".js-menu-language",

            // mobile
            sub: ".menu-page",
            burger: ".js-menu-burger",
            back: ".js-menu-back",
            collapsible: ".js-menu-page-collapsible",

            // active state
            active: ".active",
            main: ".page-wrap",
        },
        attribute: {
            target: "data-menu-target",
        },
        state: {
            active: "active",
            inactive: "inactive",
            dark: "menu-dark",
            overflow: "overflow-hidden",
            scrolled: "auto-scroll",
            pinned: "headroom--pinned",
        },
        breakpoint: {
            mobile: 767,
        },
        event: {
            scroll: "scroll.menu",
            link: "click.menu.link",
            icon: "click.menu.icon",
            language: "click.menu.language",
            keyup: "keyup.menu",
            burger: "click.menu.burger",
            back: "click.menu.back",
            collapsible: "click.menu.collapsible",
        },
        api: {
            search: "", //'https://eg.dk/sogning/?query=',
            autocomplete: "", //'https://eg.dk/api/search/autocomplete?query='
        },
        threshold: 2,
        delay: 0,
    };

    // merge options
    const options = $.extend(true, defaults, opts);

    // cache elements
    const $window = $(window);
    const $body = $(document.body);
    const $main = $(options.selector.main); // document page -wrapper
    const $menu = $(options.selector.menu); // menu header tag
    const $sub = $(options.selector.sub); // sub menu section tag
    const $nav = $menu.find(options.selector.nav); // menu nav tag
    const $search = $menu.find(options.selector.search); // search ul wrapper
    const $icon = $search.find(options.selector.icon); // search icon label
    const $input = $search.find(options.selector.input); // search input field
    const $results = $search.find(options.selector.results); // search results ul
    const $languages = $menu.find(options.selector.languages); // language selection
    const $language = $menu.find(options.selector.language); // language selection
    const $burger = $menu.find(options.selector.burger); // burger menu icon

    // headroom plugin initialization
    if (!$menu.length) return;
    const headroom = new Headroom($menu.get(0), {
        tolerance: { up: 25, down: 0 },
        offset: 0,
    }).init();

    // toggle search field
    $icon.on(options.event.icon, function (event) {
        event.preventDefault();

        // reset results
        $results.removeClass(options.state.active).html("");

        // toggle icon
        const active = $icon.hasClass(options.state.active);
        $icon.toggleClass(options.state.active, !active);

        // focus/blur input field
        if (!active)
            $input.focus(); // set focus the search field
        else $input.blur().val(""); // blur and rest the searched value
    });

    // autocomplete feature
    $input.on(options.event.keyup, function (/* event */) {
        const keycode = event.which || event.keycode;
        const phrase = $input.val();

        // threshold validation
        if (phrase.trim().length < options.threshold) {
            resetAutocompleteResults($results, options.state.active);
            return;
        }

        // redirect to search page on enter
        if (keyboard.enter == keycode) {
            location.href = `${options.api.search}${phrase}`;
            return;
        }

        // autocomplete
        // [NOTE]: introduce the delay option ONLY if the client requests this feature (use setTimeout)
        $.ajax({
            method: "GET",
            url: `${options.api.autocomplete}${phrase}`,

            success: function (data) {
                const html =
                    data && data.length
                        ? generateAutocompleteMarkup(
                              phrase,
                              data,
                              options.api.search,
                          )
                        : "";
                if (html.length > 0)
                    $results.html(html).addClass(options.state.active);
                else resetAutocompleteResults($results, options.state.active);
            },
            error: function (exc) {
                console.warn(exc);
            },
        });
    });

    // menu click handler
    $menu.on(options.event.link, options.selector.link, function (event) {
        event.preventDefault();

        // locate new active target
        const $this = $(this);
        const target = $this.attr("href");
        const $target = $menu.find(target);

        // toggle previous/new active target
        if ($this.hasClass(options.state.active)) {
            freeze(headroom, false);
            $body.removeClass(options.state.overflow);
            $menu.removeClass([options.state.active, options.state.dark]);
            $this.removeClass(options.state.active);
            $target.removeClass(options.state.active);
            $nav.removeClass(options.state.inactive);
        } else {
            freeze(headroom, true);
            $body.addClass(options.state.overflow);
            $menu.addClass([options.state.active, options.state.dark]);
            $menu
                .find(`${options.selector.link}${options.selector.active}`)
                .removeClass(options.state.active);
            $menu
                .find(`${options.selector.drawer}${options.selector.active}`)
                .removeClass(options.state.active);
            $this.addClass(options.state.active);
            $target
                .addClass(options.state.active)
                .animate({ scrollTop: 0 }, "linear");
            $nav.addClass(options.state.inactive);
        }
    });

    // back click
    $menu.on(options.event.back, options.selector.back, function (event) {
        event.preventDefault();

        $nav.removeClass(options.state.inactive);
        $menu
            .find(`${options.selector.link}${options.selector.active}`)
            .removeClass(options.state.active);
        $menu
            .find(`${options.selector.drawer}${options.selector.active}`)
            .removeClass(options.state.active);
    });

    // change language
    $language.on(options.event.language, function (event) {
        event.preventDefault();

        // toggle active state
        const active = $languages.hasClass(options.state.active);
        $languages.toggleClass(options.state.active, !active);
    });

    // burger menu
    $burger.on(options.event.burger, function (event) {
        event.preventDefault();

        const active = $menu.hasClass(options.state.active);
        if (active) {
            freeze(headroom, false);

            $body.removeClass(options.state.overflow);
            $menu
                .removeClass([options.state.active, options.state.dark])
                .children()
                .removeClass(options.state.active);
            $menu.find(options.selector.link).removeClass(options.state.active);
            $nav.removeClass(options.state.inactive);

            // cleanup active elements
            if ($icon.hasClass(options.state.active))
                $icon.trigger(options.event.icon);
            if ($languages.hasClass(options.state.active))
                $language.trigger(options.event.language);
        } else {
            freeze(headroom, true);
            $body.addClass(options.state.overflow);
            $menu
                .addClass([options.state.active, options.state.dark])
                .animate({ scrollTop: 0 }, "linear");
        }
    });

    // collapsible page menu
    $sub.on(
        options.event.collapsible,
        options.selector.collapsible,
        function (event) {
            event.preventDefault();

            if ($sub.hasClass(options.state.active)) {
                freeze(headroom, false);
                $sub.removeClass([
                    options.state.active,
                    options.state.scrolled,
                ]);
            } else {
                freeze(headroom, true);
                $sub.addClass(options.state.active);
            }
        },
    );

    // submenu scroll to top when sticky position has reached the bottom of it's container
    let scrolling = null;
    $window.on(options.event.scroll, function (e) {
        clearTimeout(scrolling);
        scrolling = setTimeout(() => {
            if (
                $sub.hasClass(options.state.active) &&
                !$sub.hasClass(options.state.scrolled)
            ) {
                const menuHeight = $menu.height();
                const subHeight = $sub.height();
                const stickyOffsetTop = $sub[0].offsetTop;
                const menuIsVisible = $menu.hasClass(options.state.pinned);
                const wrapperHeight = parseInt($main.height(), 10);
                const distance = wrapperHeight - stickyOffsetTop;

                // animate scroll
                if (distance <= subHeight) {
                    const scrollTop =
                        stickyOffsetTop - (menuIsVisible ? menuHeight : 0);
                    $("html, body").animate(
                        { scrollTop },
                        350,
                        "linear",
                        function () {
                            $sub.addClass(options.state.scrolled);
                        },
                    );
                }
            }
            scrolling = null;
        }, 350);
    });
};

export default { init };
